import { Box } from "@mui/material";
import React from "react";
import TextLabel from "../textLabelComponent/TextLabelComponent";
import LabelStatusComponent from "../labelStatusComponent/LabelStatusComponent";
import styles from "./logGroupComponent.module.scss";
import moment from "moment";
import PropTypes from "prop-types";

const LogGroupComponent = (props) => {
  const { updatedFields, updatedDate } = props;

  let label = [];

  const linstyle = {
    position: "absolute",
    width: "1px",
    height: "293px",
    marginLeft: "3px",
    marginTop: "22px",
    background: "#8c8c8c",
  };

  if (updatedFields?.length > 1) {
    linstyle.height = (98 + 60 * (updatedFields.length - 1)).toString() + "px";
  } else {
    linstyle.height = "98px";
  }

  const getDateInFormat = (updatedDate) => {
    let date = moment(updatedDate).format("ll");
    let formatedTime = moment(updatedDate).format("LT");
    return `${date} at ${formatedTime}`;
  };
  return (
    <Box className={styles.frame1} data-testid="LogGroupComponent">
      <Box className={styles.frameTextWrapper}>
        {updatedFields.map((items) => {
          label.push(items.field);

          return (
            <Box className={styles.frame2} key={`${items.field}`}>
              <Box className={styles.oneTextBoxWrapper}>
                <TextLabel
                  label={items.field}
                  value={items.new_data}
                  hasLink={false}
                  hasStrike={false}
                />
              </Box>
              <Box className={styles.leftArrow}></Box>
              <Box className={styles.oneTextBoxWrapper}>
                <TextLabel
                  label={items.field}
                  value={items.old_data}
                  hasLink={false}
                  hasStrike={true}
                />
              </Box>
            </Box>
          );
        })}
      </Box>

      <LabelStatusComponent label={label} />
      <Box className={styles.logDesign}>
        <Box className={styles.ellipse}></Box>
        <Box className={styles.logText}>{getDateInFormat(updatedDate)}</Box>
      </Box>

      <Box style={linstyle}></Box>
    </Box>
  );
};

export default LogGroupComponent;
LogGroupComponent.propTypes = {
  updatedDate:PropTypes.any,
  updatedFields:PropTypes.any
}